<template>
    <v-row>
        <v-col>            
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>                                                                                    
                            <div class="d-flex justify-space-between" style="width: 100%;">
                                <div class="d-flex justify-space-between px-3">   
                                    <!--<img class="ma-1- mx-0"  src="/icon-small.jpg" height="36" />-->
                                    <h5 class="ma-1 ml-4 mt-6" >Campaign Performance Report</h5> 
                                </div> 
                                <v-select class="ml-4"  label="Select Campaign"></v-select>
                                <div class="d-flex flex"></div>                                                         
                                
                                <v-btn class="maz-4 mt-4" dark color="primary" @click="fetchSelectedCampaignStatistics(selectedCampaign)" :loading="progressStatsLoading">
                                        <v-icon>mdi-reload</v-icon>
                                        Reload
                                </v-btn>
                            </div>
                        </v-card-title>                                        
                        <v-progress-linear
                            :active="progressStatsLoading"
                            :indeterminate="progressStatsLoading"
                            absolute
                            bottom
                            color="deep-purple accent-4"
                        />                        
                    </base-card>
                    
                    <div class="d-block text-center mt-8"> 
                        <v-progress-circular
                        v-if="progressStatsLoading"
                        indeterminate
                        color="primary"
                        ></v-progress-circular>
                        <div v-else >no cache entries found </div>
                    </div>
                </v-col>
            </v-row>

            <v-snackbar
                v-model="mysnackbar"
                :timeout="4000"
                bottom
                tile
                color="red"            
                >
                Request Failed (500): No Entries Found
            </v-snackbar>
        </v-col>
    </v-row>
</template>

<script>
import {api} from "src/api/index";
import moment from "moment";
import AdvancedGridFiltersList from "@/components/core/AdvancedGridFiltersList";
import {GGanttChart, GGanttRow} from 'vue-ganttastic';
import { GChart } from 'vue-google-charts/legacy';
import CardDashboard from "@/components/campaigns/CardDashboard";
import ReportRuleComponent from "@/components/campaigns/campaign-report-rule-component";
import {parseDate, formatDate} from '@/core/date-utils.js';
import { integerFormatting } from '@/core/number-utils.js'
// import Gantt from '@salamander.be/vue-gantt/src/components/gantt.vue';
import {
    gradientLineChart,
    salesByCountries,
    visitorsAnalytic
} from '@/data/sales2';
import {
  analyticOne,
  analyticTwo,
  analyticThree,
  analyticFour,
  analyticFive,
} from "@/data/analytic2";

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Adpoints Management'
    },    
    components: {
        "advanced-grid-filters-list": AdvancedGridFiltersList    ,
        GGanttChart,
        GGanttRow,
        GChart,
        CardDashboard,
        "report-rule-component": ReportRuleComponent
       // Gantt  
    },
    data() {
        return {            
            mysnackbar: false,
           
            progressStatsLoading: true,
            
        }
    },
    filters: {

    },
    watch: {
      
    },
    computed: {
        
    },
    methods: {
        
        async exportDocument(selectedCampaign) {
            
            await new Promise(resolve => setTimeout(resolve, 12000));
            this.progressStatsLoading = false;
            this.mysnackbar=true;
            this.progressStatsLoading=false;
        },

        
    },
    async created() {
                        
    },
    async mounted() {
        await new Promise(resolve => setTimeout(resolve, 12000));
        this.mysnackbar=true;
        this.progressStatsLoading=false;

        /*
        let ff = this.filterfields.find(i=>i.selectvalue === "brand");        
        if(ff) {
            const rsp = await api.brand.getAll();            
            ff.listItems = rsp.data.map(i=> {return {selectvalue: i.code, selecttext: i.title}});
        }
        */
    }
}
</script>
<style lang="scss">
.apexcharts-toolbar {
    //background-color: red;
    margin-top: -10px;
}
</style>

<style lang="scss" scoped>
.metrics-grid {
    //background-color: red;
    //margin-top: -10px;
    display: grid;
    grid-template-columns: repeat(8, 1fs [col-start]);
    grid-template-rows: [row1-top] 1fs [row2-bottom] 1fs;
    column-gap: 24px;
    row-gap: 12px;
}

.metrics-griditem {
    //background-color: red;
    //margin-top: -10px;
    
    //border: 2px red solid;
}

.v-card .v-list-item {
    // color: #304156 !important;
}

</style>
